(() => {
  const TOAST_DURATION = 3600;
  const TOAST_SELECTOR = '[data-wc-cart-toast]';
  let hideTimer;

  const moneyFormatter = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
    style: 'currency',
    currency: 'EUR',
  });

  const injectStyles = () => {
    if (document.getElementById('wc-cart-toast-styles')) return;

    const style = document.createElement('style');
    style.id = 'wc-cart-toast-styles';
    style.textContent = `
      .wc-cart-toast {
        position: fixed;
        top: clamp(16px, 3vw, 28px);
        right: clamp(14px, 3vw, 28px);
        z-index: 120;
        width: min(380px, calc(100vw - 28px));
        pointer-events: none;
        opacity: 0;
        transform: translate3d(0, -14px, 0) scale(0.98);
        transition: opacity 700ms ease, transform 700ms cubic-bezier(0.22, 1, 0.36, 1);
      }

      .wc-cart-toast.is-visible {
        opacity: 1;
        transform: translate3d(0, 0, 0) scale(1);
        pointer-events: auto;
      }

      .wc-cart-toast.is-hiding {
        opacity: 0;
        transform: translate3d(0, -8px, 0) scale(0.985);
        transition-duration: 1100ms;
      }

      .wc-cart-toast__inner {
        display: grid;
        grid-template-columns: 72px 1fr auto;
        gap: 14px;
        align-items: center;
        min-height: 96px;
        padding: 12px;
        color: #111;
        background: rgba(255, 255, 255, 0.96);
        border: 1px solid rgba(17, 17, 17, 0.1);
        box-shadow: 0 18px 48px rgba(17, 17, 17, 0.16);
        backdrop-filter: blur(12px);
      }

      .wc-cart-toast__media {
        display: block;
        width: 72px;
        aspect-ratio: 3 / 4;
        overflow: hidden;
        background: rgb(248, 248, 248);
      }

      .wc-cart-toast__image {
        width: 100%;
        height: 100%;
        display: block;
        object-fit: cover;
      }

      .wc-cart-toast__content {
        min-width: 0;
      }

      .wc-cart-toast__eyebrow {
        margin: 0 0 6px;
        font: inherit;
        font-size: 0.72rem;
        letter-spacing: 0.06em;
        text-transform: uppercase;
        color: rgba(17, 17, 17, 0.58);
      }

      .wc-cart-toast__title {
        display: block;
        margin-bottom: 4px;
        color: inherit;
        font-size: 0.94rem;
        line-height: 1.25;
        text-decoration: none;
      }

      .wc-cart-toast__extra-name {
        display: block;
        margin: -1px 0 5px;
        color: rgba(17, 17, 17, 0.52);
        font-size: 0.8rem;
        line-height: 1.25;
      }

      .wc-cart-toast__meta {
        display: block;
        font-size: 0.82rem;
        color: rgba(17, 17, 17, 0.62);
      }

      .wc-cart-toast__close {
        align-self: start;
        display: grid;
        width: 30px;
        height: 30px;
        padding: 0;
        place-items: center;
        border: 0;
        color: inherit;
        background: transparent;
        cursor: pointer;
      }

      .wc-cart-toast__close svg {
        width: 16px;
        height: 16px;
      }

      .wc-cart-toast__actions {
        grid-column: 2 / 4;
        display: flex;
        gap: 12px;
        align-items: center;
        margin-top: -6px;
      }

      .wc-cart-toast__link {
        display: inline-flex;
        min-height: 38px;
        padding: 0 18px;
        align-items: center;
        justify-content: center;
        color: #fff;
        background: #41344A;
        font-size: 0.78rem;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        text-decoration: none;
        text-underline-offset: 4px;
      }

      .wc-cart-toast--error .wc-cart-toast__inner {
        grid-template-columns: 1fr auto;
        min-height: 74px;
      }

      .wc-cart-toast--error .wc-cart-toast__content {
        grid-column: 1;
      }

      .wc-cart-toast--error .wc-cart-toast__actions,
      .wc-cart-toast--error .wc-cart-toast__media {
        display: none;
      }

      @media (max-width: 749px) {
        .wc-cart-toast {
          top: auto;
          right: 12px;
          bottom: 14px;
          width: calc(100vw - 24px);
          transform: translate3d(0, 16px, 0) scale(0.98);
        }

        .wc-cart-toast.is-visible {
          transform: translate3d(0, 0, 0) scale(1);
        }

        .wc-cart-toast.is-hiding {
          transform: translate3d(0, 10px, 0) scale(0.985);
        }
      }
    `;
    document.head.appendChild(style);
  };

  const escapeHtml = (value = '') => {
    const div = document.createElement('div');
    div.textContent = value;
    return div.innerHTML;
  };

  const formatMoney = (cents, currency = 'EUR') => {
    if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents);

    if (currency !== 'EUR') {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
          style: 'currency',
          currency,
        }).format(cents / 100);
      } catch (error) {
        return moneyFormatter.format(cents / 100);
      }
    }

    return moneyFormatter.format(cents / 100);
  };

  const getToast = () => {
    let toast = document.querySelector(TOAST_SELECTOR);
    if (toast) return toast;

    toast = document.createElement('aside');
    toast.className = 'wc-cart-toast';
    toast.setAttribute('data-wc-cart-toast', '');
    toast.setAttribute('aria-live', 'polite');
    toast.setAttribute('aria-hidden', 'true');
    document.body.appendChild(toast);
    return toast;
  };

  const hideToast = () => {
    const toast = document.querySelector(TOAST_SELECTOR);
    if (!toast) return;

    toast.classList.add('is-hiding');
    toast.classList.remove('is-visible');
    toast.setAttribute('aria-hidden', 'true');
  };

  const scheduleHide = () => {
    window.clearTimeout(hideTimer);
    hideTimer = window.setTimeout(hideToast, TOAST_DURATION);
  };

  const showToast = (item, cart) => {
    injectStyles();

    const toast = getToast();
    const image = item.image ? `<img class="wc-cart-toast__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title || item.title)}" loading="lazy">` : '';
    const itemUrl = item.url || '/cart';
    const quantity = item.quantity || 1;
    const price = typeof item.final_price === 'number' ? item.final_price : item.price;
    const extraName = item.properties?._product_extra_naam || '';

    toast.className = 'wc-cart-toast';
    toast.innerHTML = `
      <div class="wc-cart-toast__inner">
        <a class="wc-cart-toast__media" href="${escapeHtml(itemUrl)}" aria-label="${escapeHtml(item.product_title || item.title)}">
          ${image}
        </a>
        <div class="wc-cart-toast__content">
          <p class="wc-cart-toast__eyebrow">Toegevoegd aan winkelwagen</p>
          <a class="wc-cart-toast__title" href="${escapeHtml(itemUrl)}">${escapeHtml(item.product_title || item.title)}</a>
          ${extraName ? `<span class="wc-cart-toast__extra-name">${escapeHtml(extraName)}</span>` : ''}
          <span class="wc-cart-toast__meta">${quantity} x ${formatMoney(price, cart?.currency)}</span>
        </div>
        <button class="wc-cart-toast__close" type="button" aria-label="Sluiten" data-wc-cart-toast-close>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M4.75 4.75 15.25 15.25M15.25 4.75 4.75 15.25" stroke="currentColor" stroke-linecap="round" stroke-width="1.1"></path>
          </svg>
        </button>
        <div class="wc-cart-toast__actions">
          <a class="wc-cart-toast__link" href="/checkout">Afrekenen</a>
        </div>
      </div>
    `;

    window.requestAnimationFrame(() => {
      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');
    });
    scheduleHide();
  };

  const showErrorToast = (message, heading = 'Niet toegevoegd') => {
    injectStyles();

    const toast = getToast();
    toast.className = 'wc-cart-toast wc-cart-toast--error';
    toast.innerHTML = `
      <div class="wc-cart-toast__inner">
        <div class="wc-cart-toast__content">
          <p class="wc-cart-toast__eyebrow">${escapeHtml(heading)}</p>
          <span class="wc-cart-toast__title">${escapeHtml(message || 'Dit product kon niet worden toegevoegd.')}</span>
        </div>
        <button class="wc-cart-toast__close" type="button" aria-label="Sluiten" data-wc-cart-toast-close>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <path d="M4.75 4.75 15.25 15.25M15.25 4.75 4.75 15.25" stroke="currentColor" stroke-linecap="round" stroke-width="1.1"></path>
          </svg>
        </button>
      </div>
    `;

    window.requestAnimationFrame(() => {
      toast.classList.add('is-visible');
      toast.setAttribute('aria-hidden', 'false');
    });
    scheduleHide();
  };

  const buildCartAddPayload = (form, submitter) => {
    const source = new FormData(form);
    const payload = new FormData();
    const submittedId = submitter?.name === 'id' ? submitter.value : null;
    const id = submittedId || source.get('id');

    if (!id) return null;

    payload.append('id', id);
    payload.append('quantity', source.get('quantity') || '1');

    source.forEach((value, key) => {
      if (key.startsWith('properties[') || key === 'selling_plan') {
        payload.append(key, value);
      }
    });

    return payload;
  };

  const updateCartCount = (cart) => {
    if (!cart) return;

    document.querySelectorAll('.header__cart-count').forEach((count) => {
      count.textContent = cart.item_count;
    });

    document.querySelectorAll('.wc-cart-drawer__title span').forEach((count) => {
      count.textContent = cart.item_count;
    });
  };

  const refreshCart = async () => {
    const response = await fetch('/cart.js', {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) return null;

    const cart = await response.json();
    updateCartCount(cart);
    return cart;
  };

  const renderCartItems = (cart) => {
    if (!cart?.items?.length) {
      return `
        <div class="wc-cart-drawer__empty">
          <p>Je winkelwagen is leeg.</p>
        </div>
      `;
    }

    const items = cart.items.map((item, index) => {
      const image = item.image ? `<img class="wc-cart-item__image" src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="wc-cart-item__variant">${escapeHtml(item.variant_title)}</p>` : '';
      const extraName = item.properties?._product_extra_naam || '';

      return `
        <li class="wc-cart-item">
          <a href="${escapeHtml(item.url)}" class="wc-cart-item__media" tabindex="-1" aria-hidden="true">
            ${image}
          </a>

          <div class="wc-cart-item__content">
            <div class="wc-cart-item__meta">
              <a href="${escapeHtml(item.url)}" class="wc-cart-item__title">${escapeHtml(item.product_title)}</a>
              ${extraName ? `<p class="wc-cart-item__extra-name">${escapeHtml(extraName)}</p>` : ''}
              ${variant}
              <p class="wc-cart-item__price">${formatMoney(item.final_line_price, cart.currency)}</p>
            </div>

            <div class="wc-cart-item__actions">
              <div class="wc-cart-item__quantity" data-wc-cart-line="${index + 1}">
                <button type="button" data-wc-cart-quantity-minus aria-label="Aantal verlagen">-</button>
                <input
                  type="number"
                  name="updates[]"
                  value="${item.quantity}"
                  min="0"
                  inputmode="numeric"
                  aria-label="Aantal"
                  data-wc-cart-quantity-input
                >
                <button type="button" data-wc-cart-quantity-plus aria-label="Aantal verhogen">+</button>
              </div>

              <a href="/cart/change?line=${index + 1}&quantity=0" class="wc-cart-item__remove">
                Verwijderen
              </a>
            </div>
          </div>
        </li>
      `;
    }).join('');

    return `<ul class="wc-cart-drawer__items" role="list">${items}</ul>`;
  };

  const renderFreeShippingProgress = (cart, drawer) => {
    if (!cart || !drawer || drawer.dataset.freeShippingEnabled !== 'true' || cart.item_count <= 0) return '';

    const threshold = Number.parseInt(drawer.dataset.freeShippingThreshold, 10) || 5995;
    const remaining = Math.max(threshold - cart.total_price, 0);
    const progress = Math.min(Math.max((cart.total_price / threshold) * 100, 0), 100);
    const complete = remaining <= 0;

    return `
      <div
        class="wc-cart-drawer__shipping-progress${complete ? ' is-complete' : ''}"
        style="--wc-cart-shipping-progress: ${progress.toFixed(2)}%;"
        data-wc-free-shipping-progress
      >
        <div class="wc-cart-drawer__shipping-copy" data-wc-free-shipping-text>
          ${complete
            ? 'Je verzending is gratis.'
            : `Nog <strong>${formatMoney(remaining, cart.currency)}</strong> en je verzending is gratis.`
          }
        </div>
        <div class="wc-cart-drawer__shipping-track" aria-hidden="true">
          <span></span>
        </div>
      </div>
    `;
  };

  const renderCartDrawerFromSection = async (drawer) => {
    const sectionId = drawer?.dataset.wcCartSectionId;
    if (!drawer || !sectionId) return false;

    try {
      const response = await fetch(`/?sections=${encodeURIComponent(sectionId)}&_=${Date.now()}`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
        cache: 'no-store',
      });

      if (!response.ok) return false;

      const sections = await response.json();
      const html = sections?.[sectionId];
      if (!html) return false;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextDrawer = parsed.querySelector('[data-wc-cart-drawer]');
      const nextForm = nextDrawer?.querySelector('.wc-cart-drawer__form');
      const currentForm = drawer.querySelector('.wc-cart-drawer__form');
      const nextCount = nextDrawer?.querySelector('.wc-cart-drawer__title span')?.textContent;
      const currentCount = drawer.querySelector('.wc-cart-drawer__title span');
      if (!nextForm || !currentForm) return false;

      currentForm.innerHTML = nextForm.innerHTML;
      if (currentCount && nextCount != null) currentCount.textContent = nextCount;
      return true;
    } catch (error) {
      return false;
    }
  };

  const renderCartDrawer = async (cart) => {
    const drawer = document.querySelector('[data-wc-cart-drawer]');
    const form = drawer?.querySelector('.wc-cart-drawer__form');
    if (!drawer || !form || !cart) return;

    drawer.querySelectorAll('.wc-cart-drawer__title span').forEach((count) => {
      count.textContent = cart.item_count;
    });

    if (await renderCartDrawerFromSection(drawer)) return;

    form.dataset.wcCartRendered = 'true';
    form.innerHTML = `
      <div class="wc-cart-drawer__body">
        ${renderCartItems(cart)}
      </div>

      ${renderFreeShippingProgress(cart, drawer)}

      <div class="wc-cart-drawer__footer">
        <div class="wc-cart-drawer__subtotal">
          <span>Subtotaal</span>
          <strong>${formatMoney(cart.total_price, cart.currency)}</strong>
        </div>

        ${cart.item_count > 0 ? `
          <a href="/checkout" class="wc-cart-drawer__cart-link">Afrekenen</a>
          <div class="wc-cart-drawer__payment-trust" aria-label="Veilig betalen met iDEAL, PayPal en creditcard">
            <span>Veilig betalen met iDEAL, PayPal en creditcard</span>
          </div>
        ` : ''}
      </div>
    `;
  };

  const getVariantQuantityIssue = (select, quantity) => {
    const option = select?.selectedOptions?.[0];
    if (!option) return 'Deze maat kon niet worden gevonden.';

    if (option.dataset.available !== 'true' && option.value !== select.dataset.currentVariantId) {
      return 'Deze maat is uitverkocht.';
    }

    const inventoryQuantity = Number.parseInt(option.dataset.inventoryQuantity, 10);
    const tracksInventory = Boolean(option.dataset.inventoryManagement);
    const deniesOversell = option.dataset.inventoryPolicy !== 'continue';
    if (tracksInventory && deniesOversell && Number.isFinite(inventoryQuantity) && inventoryQuantity >= 0 && quantity > inventoryQuantity) {
      return inventoryQuantity === 1
        ? 'Er is nog 1 item van deze maat op voorraad.'
        : `Er zijn nog ${inventoryQuantity} items van deze maat op voorraad.`;
    }

    return '';
  };

  const changeCartLineVariant = async (select) => {
    const item = select.closest('.wc-cart-item');
    const key = select.dataset.wcCartKey || item?.dataset.wcCartKey;
    const variantId = select.value;
    const currentVariantId = select.dataset.currentVariantId;
    const quantityInput = item?.querySelector('[data-wc-cart-quantity-input]');
    const quantity = Math.max(Number.parseInt(quantityInput?.value, 10) || 1, 1);

    if (!key || !variantId || variantId === currentVariantId) return;

    const issue = getVariantQuantityIssue(select, quantity);
    if (issue) {
      showErrorToast(issue, 'Niet aangepast');
      select.value = currentVariantId;
      return;
    }

    item?.setAttribute('aria-busy', 'true');
    item?.querySelectorAll('button, input, select').forEach((element) => {
      element.disabled = true;
    });

    try {
      const addPayload = new FormData();
      addPayload.append('id', variantId);
      addPayload.append('quantity', String(quantity));

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: addPayload,
      });
      const addData = await addResponse.json();

      if (!addResponse.ok) {
        showErrorToast(addData.description || addData.message || 'Deze maat heeft niet genoeg voorraad.', 'Niet aangepast');
        select.value = currentVariantId;
        return;
      }

      const removePayload = new FormData();
      removePayload.append('id', key);
      removePayload.append('quantity', '0');

      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: removePayload,
      });
      const cart = await removeResponse.json();

      if (!removeResponse.ok) {
        showErrorToast(cart.description || cart.message || 'Maat kon niet worden aangepast.', 'Niet aangepast');
        return;
      }

      updateCartCount(cart);
      await renderCartDrawer(cart);
    } catch (error) {
      showErrorToast('Maat kon niet worden aangepast.', 'Niet aangepast');
      select.value = currentVariantId;
    } finally {
      item?.removeAttribute('aria-busy');
      item?.querySelectorAll('button, input, select').forEach((element) => {
        element.disabled = false;
      });
    }
  };

  const openCartDrawer = () => {
    const drawer = document.querySelector('[data-wc-cart-drawer]');
    if (!drawer) return;

    hideToast();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('wc-cart-drawer-open');
  };

  const getCartChangePayload = (link) => {
    const url = new URL(link.href, window.location.origin);
    const line = url.searchParams.get('line');
    const id = url.searchParams.get('id');
    const payload = new FormData();

    if (line) {
      payload.append('line', line);
    } else if (id) {
      payload.append('id', id);
    } else {
      return null;
    }

    payload.append('quantity', '0');
    return payload;
  };

  const removeCartItem = async (link) => {
    const payload = getCartChangePayload(link);
    if (!payload) return false;

    link.setAttribute('aria-busy', 'true');
    link.style.pointerEvents = 'none';

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload,
      });
      const cart = await response.json();

      if (!response.ok) {
        showErrorToast(cart.description || cart.message || 'Dit product kon niet worden verwijderd.', 'Niet verwijderd');
        return true;
      }

      updateCartCount(cart);
      await renderCartDrawer(cart);
      return true;
    } catch (error) {
      showErrorToast('Dit product kon niet worden verwijderd.', 'Niet verwijderd');
      return true;
    } finally {
      link.removeAttribute('aria-busy');
      link.style.pointerEvents = '';
    }
  };

  const changeCartLineQuantity = async (control, quantity) => {
    const quantityGroup = control.closest('.wc-cart-item__quantity');
    const item = control.closest('.wc-cart-item');
    const line = quantityGroup?.dataset.wcCartLine;
    const input = quantityGroup?.querySelector('[data-wc-cart-quantity-input]');
    if (!line || !input) return false;

    const nextQuantity = Math.max(Number(quantity) || 0, 0);
    const variantSelect = item?.querySelector('[data-wc-cart-variant-select]');
    const issue = getVariantQuantityIssue(variantSelect, nextQuantity);
    if (issue) {
      showErrorToast(issue, 'Niet aangepast');
      input.value = input.defaultValue || input.getAttribute('value') || '1';
      return true;
    }

    const payload = new FormData();
    payload.append('line', line);
    payload.append('quantity', String(nextQuantity));

    quantityGroup.setAttribute('aria-busy', 'true');
    quantityGroup.querySelectorAll('button, input').forEach((element) => {
      element.disabled = true;
    });

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload,
      });
      const cart = await response.json();

      if (!response.ok) {
        showErrorToast(cart.description || cart.message || 'Aantal kon niet worden aangepast.', 'Niet aangepast');
        return true;
      }

      updateCartCount(cart);
      await renderCartDrawer(cart);
      return true;
    } catch (error) {
      showErrorToast('Aantal kon niet worden aangepast.', 'Niet aangepast');
      return true;
    } finally {
      quantityGroup.removeAttribute('aria-busy');
      quantityGroup.querySelectorAll('button, input').forEach((element) => {
        element.disabled = false;
      });
    }
  };

  const isSupportedAddForm = (form, submitter) => {
    if (!form || !form.matches('form')) return false;
    if (form.matches('[data-product-form]')) return submitter?.matches('[data-add-to-cart]');

    const action = form.getAttribute('action') || '';
    return action.includes('/cart/add');
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    const submitter = event.submitter || document.activeElement;

    const supportedAddForm = isSupportedAddForm(form, submitter);

    if (form.closest('[data-wc-cart-drawer]') && !supportedAddForm) {
      event.preventDefault();
      return;
    }

    if (!supportedAddForm) return;

    if (form.dataset.notifySelected === 'true' || form.dataset.backInStock === 'true') {
      event.preventDefault();
      return;
    }

    const payload = buildCartAddPayload(form, submitter);
    if (!payload) return;

    event.preventDefault();

    const buttons = Array.from(form.querySelectorAll('button[type="submit"], input[type="submit"]'));
    buttons.forEach((button) => {
      if (button.disabled) button.dataset.wcCartWasDisabled = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload,
      });

      const data = await response.json();

      if (!response.ok) {
        showErrorToast(data.description || data.message);
        return;
      }

      const cart = await refreshCart();
      await renderCartDrawer(cart);
      openCartDrawer();
    } catch (error) {
      showErrorToast('Dit product kon niet worden toegevoegd.');
    } finally {
      buttons.forEach((button) => {
        button.disabled = button.dataset.wcCartWasDisabled === 'true';
        delete button.dataset.wcCartWasDisabled;
        button.removeAttribute('aria-busy');
      });
    }
  });

  const closeTpcQuickCard = (card) => {
    if (!card) return;
    card.classList.remove('is-quick-open', 'is-touch-active');
    card.querySelector('[data-lpg-quick-trigger]')?.setAttribute('aria-expanded', 'false');
    card.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'true');
  };

  const addTpcQuickFormToCart = async (quickForm, submitter) => {
    const payload = buildCartAddPayload(quickForm, submitter);
    if (!payload) return;

    const buttons = Array.from(quickForm.querySelectorAll('button[type="submit"], input[type="submit"]'));
    buttons.forEach((button) => {
      if (button.disabled) button.dataset.wcCartWasDisabled = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    });

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: payload,
      });

      const data = await response.json();

      if (!response.ok) {
        showErrorToast(data.description || data.message);
        return;
      }

      const cart = await refreshCart();
      await renderCartDrawer(cart);
      openCartDrawer();
      closeTpcQuickCard(quickForm.closest('[data-lpg-product-card]'));
    } catch (error) {
      showErrorToast('Dit product kon niet worden toegevoegd.');
    } finally {
      buttons.forEach((button) => {
        button.disabled = button.dataset.wcCartWasDisabled === 'true';
        delete button.dataset.wcCartWasDisabled;
        button.removeAttribute('aria-busy');
      });
    }
  };

  document.addEventListener('click', async (event) => {
    const trigger = event.target.closest('.tpc-section [data-lpg-quick-trigger]');
    const addButton = event.target.closest('.tpc-section .lpg-product-card__add-button');
    const closeButton = event.target.closest('.tpc-section [data-lpg-quick-close]');
    const choice = event.target.closest('.tpc-section [data-lpg-variant-choice]');

    if (!trigger && !addButton && !closeButton && !choice) return;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    if (closeButton) {
      closeTpcQuickCard(closeButton.closest('[data-lpg-product-card]'));
      return;
    }

    if (choice) {
      const card = choice.closest('[data-lpg-product-card]');
      const selectedInput = card?.querySelector('[data-lpg-selected-variant]');
      const selectedSize = card?.querySelector('[data-lpg-selected-size]');
      const quickForm = card?.querySelector('[data-lpg-quick-panel]');
      const add = card?.querySelector('.lpg-product-card__add-button');
      const isAvailable = choice.dataset.available === 'true';
      const variantText = choice.textContent.trim();

      if (selectedInput) {
        selectedInput.value = choice.dataset.variantId;
        selectedInput.dataset.variantTitle = choice.dataset.variantTitle || variantText;
      }

      if (selectedSize && variantText) selectedSize.textContent = variantText;
      if (quickForm) quickForm.dataset.notifySelected = isAvailable ? 'false' : 'true';
      if (add) {
        add.innerHTML = isAvailable
          ? '<span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--full">Toevoegen aan winkelwagen</span><span class="lpg-product-card__add-button-text lpg-product-card__add-button-text--short">Toevoegen</span>'
          : 'Meld mij aan';
      }

      card?.querySelectorAll('[data-lpg-variant-choice]').forEach((button) => {
        button.classList.toggle('is-selected', button === choice);
      });

      return;
    }

    if (trigger) {
      const card = trigger.closest('[data-lpg-product-card]');
      if (!card || trigger.disabled) return;
      card.classList.remove('is-touch-active');

      if (trigger.dataset.lpgDirectAdd === 'true') {
        const quickForm = card.querySelector('[data-lpg-quick-panel]');
        const submitter = quickForm?.querySelector('.lpg-product-card__add-button');
        await addTpcQuickFormToCart(quickForm, submitter);
        return;
      }

      const isOpen = card.classList.contains('is-quick-open');
      card.closest('.tpc-section')?.querySelectorAll('[data-lpg-product-card].is-quick-open').forEach((openCard) => {
        if (openCard !== card) closeTpcQuickCard(openCard);
      });

      if (isOpen) {
        closeTpcQuickCard(card);
      } else {
        card.classList.add('is-quick-open');
        trigger.setAttribute('aria-expanded', 'true');
        card.querySelector('[data-lpg-quick-panel]')?.setAttribute('aria-hidden', 'false');
      }

      return;
    }

    if (addButton) {
      const card = addButton.closest('[data-lpg-product-card]');
      const quickForm = card?.querySelector('[data-lpg-quick-panel]');

      if (quickForm?.dataset.notifySelected === 'true') {
        const selectedChoice = card?.querySelector('[data-lpg-variant-choice].is-selected');
        const selectedInput = card?.querySelector('[data-lpg-selected-variant]');
        window.dispatchEvent(new CustomEvent('wc:back-in-stock:open', {
          detail: {
            productTitle: card?.dataset.productTitle || '',
            productHandle: card?.dataset.productHandle || '',
            variantId: selectedChoice?.dataset.variantId || selectedInput?.value || '',
            variantTitle: selectedChoice?.dataset.variantTitle || selectedInput?.dataset.variantTitle || card?.querySelector('[data-lpg-selected-size]')?.textContent?.trim() || '',
          },
        }));
        return;
      }

      await addTpcQuickFormToCart(quickForm, addButton);
    }
  }, true);

  document.addEventListener('click', async (event) => {
    if (event.target.closest('[data-wc-cart-toast-close]')) {
      window.clearTimeout(hideTimer);
      hideToast();
    }

    const removeLink = event.target.closest('.wc-cart-item__remove');
    if (removeLink?.closest('[data-wc-cart-drawer]')) {
      event.preventDefault();
      await removeCartItem(removeLink);
      return;
    }

    const quantityButton = event.target.closest('[data-wc-cart-quantity-minus], [data-wc-cart-quantity-plus]');
    if (!quantityButton?.closest('[data-wc-cart-drawer]')) return;

    const input = quantityButton.closest('.wc-cart-item__quantity')?.querySelector('[data-wc-cart-quantity-input]');
    if (!input) return;

    const direction = quantityButton.matches('[data-wc-cart-quantity-plus]') ? 1 : -1;
    await changeCartLineQuantity(quantityButton, Number(input.value || 0) + direction);
  });

  document.addEventListener('change', async (event) => {
    const variantSelect = event.target.closest('[data-wc-cart-variant-select]');
    if (variantSelect?.closest('[data-wc-cart-drawer]')) {
      await changeCartLineVariant(variantSelect);
      return;
    }

    const input = event.target.closest('[data-wc-cart-quantity-input]');
    if (!input?.closest('[data-wc-cart-drawer]')) return;

    await changeCartLineQuantity(input, input.value);
  });

  document.addEventListener('wc:cart:refresh', async () => {
    const cart = await refreshCart();
    if (cart) await renderCartDrawer(cart);
  });

  window.WcCartDrawer = {
    refresh: async () => {
      const cart = await refreshCart();
      if (cart) await renderCartDrawer(cart);
    },
    render: renderCartDrawer,
    showError: showErrorToast,
  };
})();
